/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPNATUREOFPERSON } from './IAPNATUREOFPERSON';
import {
    IAPNATUREOFPERSONFromJSON,
    IAPNATUREOFPERSONFromJSONTyped,
    IAPNATUREOFPERSONToJSON,
} from './IAPNATUREOFPERSON';

/**
 * 
 * @export
 * @interface NonTaxableInstitutionPartyDetailsViewModel
 */
export interface NonTaxableInstitutionPartyDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    natureOfNonTaxableInstitutionId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {string}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    registeredName?: string;
    /**
     * 
     * @type {string}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    tradingName?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    countryOfOperation?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    countryOfRegistration?: IAPCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof NonTaxableInstitutionPartyDetailsViewModel
     */
    dateOfRegistration?: Date;
}

/**
 * Check if a given object implements the NonTaxableInstitutionPartyDetailsViewModel interface.
 */
export function instanceOfNonTaxableInstitutionPartyDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonTaxableInstitutionPartyDetailsViewModelFromJSON(json: any): NonTaxableInstitutionPartyDetailsViewModel {
    return NonTaxableInstitutionPartyDetailsViewModelFromJSONTyped(json, false);
}

export function NonTaxableInstitutionPartyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonTaxableInstitutionPartyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'natureOfNonTaxableInstitutionId': !exists(json, 'NatureOfNonTaxableInstitutionId') ? undefined : IAPNATUREOFPERSONFromJSON(json['NatureOfNonTaxableInstitutionId']),
        'registeredName': !exists(json, 'RegisteredName') ? undefined : json['RegisteredName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'countryOfOperation': !exists(json, 'CountryOfOperation') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfOperation']),
        'countryOfRegistration': !exists(json, 'CountryOfRegistration') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfRegistration']),
        'dateOfRegistration': !exists(json, 'DateOfRegistration') ? undefined : (new Date(json['DateOfRegistration'])),
    };
}

export function NonTaxableInstitutionPartyDetailsViewModelToJSON(value?: NonTaxableInstitutionPartyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'NatureOfNonTaxableInstitutionId': IAPNATUREOFPERSONToJSON(value.natureOfNonTaxableInstitutionId),
        'RegisteredName': value.registeredName,
        'RegistrationNumber': value.registrationNumber,
        'TradingName': value.tradingName,
        'CountryOfOperation': IAPCOUNTRYToJSON(value.countryOfOperation),
        'CountryOfRegistration': IAPCOUNTRYToJSON(value.countryOfRegistration),
        'DateOfRegistration': value.dateOfRegistration === undefined ? undefined : (value.dateOfRegistration.toISOString()),
    };
}

